import { domainMapping, globalDomains } from '@/config/domain-mapping';
import store from '@app/store';
import router from '@app/router/index.APP_TARGET';
import { appConfig } from '@/config/app-config';

export default class ClientRouterService {
  get tenantAlias(): string {
    return store.getters['tenant/tenantAlias'] || null;
  }

  set tenantAlias(value) {
    store.commit('tenant/setTenantAlias', value);
  }

  getContext() {
    const profileBaseRoute = this.getClientUrl('profile');
    const path = router.currentRoute.path;
    if (path.includes(profileBaseRoute)) {
      return 'profile';
    }
    const adminBaseRoute = this.getClientUrl('admin');
    if (path.includes(adminBaseRoute)) {
      return 'admin';
    }

    return 'public';
  }

  setTenantAlias(alias: string) {
    this.tenantAlias = alias;
  }

  getTenantAlias() {
    return this.tenantAlias;
  }

  hasCustomDomain(): boolean {
    // for example currentDomain = mounier.big-captain.com
    const currentDomain = this.getDomain();
    if (currentDomain === 'localhost' || currentDomain === '195.15.215.220') {
      // NOTE: if we are in localhost we have to set a domain mapping
      // to match localhost with a tenantalias
      return true;
    }
    const matchedDomain = globalDomains.find(domConfig => currentDomain.includes(domConfig.domain));
    return !matchedDomain;
  }

  getDomain(): string {
    // return 'new.myawbb.com';
    const hostname = window.location.hostname;
    return hostname;
  }

  getTenantAliasFromCustomDomain(): string {
    const domain = this.getDomain();
    const currentDomainMap = domainMapping.find(domainMap => domainMap.domain === domain);
    return currentDomainMap?.alias;
  }

  getTenantAliasFromSubDomain(): string {
    const domain = this.getDomain();
    const matchedDomain = globalDomains.find(domConfig => domain.includes(domConfig.domain));
    if (!matchedDomain) {
      return null;
    }
    const tenantAlias = domain.replace(`.${matchedDomain.domain}`, '');
    return tenantAlias;
  }

  getTenantAliasFromUrl(): string {
    if (this.hasCustomDomain()) {
      return this.getTenantAliasFromCustomDomain();
    }

    return this.getTenantAliasFromSubDomain();
  }

  getTenantDomain(tenantAlias: string) {
    if (this.isLocalHost()) {
      return window.location.host;
    }

    const domainMappingConfig = domainMapping.find(config => config.alias === tenantAlias);

    if (domainMappingConfig) {
      return domainMappingConfig.domain;
    }
    const baseDomain = appConfig.baseDomain;

    return `${tenantAlias}.${baseDomain}`;
  }

  isLocalHost(): boolean {
    const hostname = window.location.hostname;
    return hostname.startsWith('localhost');
  }

  getClientUrl(path: string) {
    return this.addInitialSlash(path);
  }

  getOrigin(): string {
    // return 'https://new.myawbb.com';
    const origin = window.location.origin;
    return origin;
  }

  getFullClientUrl(path: string) {
    return `${this.getOrigin()}${this.getClientUrl(path)}`;
  }

  addInitialSlash(str: string): string {
    return str.startsWith('/') ? str : `/${str}`;
  }

  removeFinalSlash(str: string): string {
    return str.replace(/\/$/, '');
  }
  removeInitialSlash(str: string): string {
    return str.replace(/^\//, '');
  }

  getPaymentProcessRouteName(): string {
    if (store.getters['centerSettings/allowAccessClientSection']) {
      return 'profile-payment-process';
    }
    // FIXME Maybe remove this part
    if (store.getters['centerSettings/allowAccessPublicWebsite']) {
      return 'public-payment-process';
    }
    return null;
  }

  getPaymentProcessRouteNameV2(): string {
    if (store.getters['centerSettings/allowAccessClientSection']) {
      return 'profile-shopping-cart';
    }
    return null;
  }

  redirectToCmsV2(tenantAlias = null, path = null) {
    const protocol = window.location.protocol;
    const tenantAliasToUse = tenantAlias || this.tenantAlias;
    const domain = this.getTenantDomain(tenantAliasToUse);
    const redirectUrl = path ? `${protocol}//${domain}/web/${path}` : `${protocol}//${domain}/web`;
    window.location.href = redirectUrl;
  }

  getDeepLinkBaseUrl(): string {
    return 'https://app.big-captain.com';
  }
}

export const $clientRouter = new ClientRouterService();
